// components/Loading.js

import React from "react";

// Add a prop
const Loading = ({
  message = "Loading...",
  size = "md",
  fullscreen = false,
  loaderColor = "blue",
}) => {
  const sizeClasses = {
    sm: "h-4 w-4 border-2",
    md: "h-6 w-6 border-4",
    lg: "h-10 w-10 border-4",
  };

  return (
    <div
      className={`${
        fullscreen ? "fixed inset-0 bg-white z-50" : ""
      } flex flex-col items-center justify-center`}
    >
      <div
        className={`animate-spin rounded-full border-t-transparent border-${loaderColor}-500 ${sizeClasses[size]}`}
      />
      {message && <p className="mt-2 text-sm text-gray-600">{message}</p>}
    </div>
  );
};

export default Loading;
